// extracted by mini-css-extract-plugin
export default {"spacer":"GiftCardPaymentContainer-module__spacer___1Uwbq"};